import Badge from "parts/Badge";
import React from "react";

export default function NewWorkItem({ image, link, name, type, desc, tech }) {
	return (
		<div className="mb-8 border-b border-blue-200 pb-8">
			<div className="text-3xl font-bold">{name}</div>
			<div className="my-3">{desc}</div>
			<div className="flex flex-row gap-2">
				{tech.map((item, i) => (
					<Badge name={item} key={i} />
				))}
			</div>
			<a
				href={link}
				target={"_blank"}
				rel="noreferrer"
				className="inline-flex gap-1 mt-8 text-blue-700 text-xs font-bold cursor-pointer hover:underline"
			>
				<span>Visit The page</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 20 20"
					fill="currentColor"
					className="w-4 h-4"
				>
					<path
						fillRule="evenodd"
						d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"
						clipRule="evenodd"
					/>
				</svg>
			</a>
		</div>
	);
}
